import MODULES from '../config/modules.config';
import useAuth from './useAuth';

/**
 * Hook to manage and check module-based access and permissions
 */
export const useModuleStatus = () => {
  const { permissionsInfo, modulesInfo } = useAuth();

  // Extract all active module IDs from the subscription info
  const activeModuleIds: string[] = modulesInfo?.map((m) => m.moduleId) || [];

  // Get raw permission object for a specific module
  const getPermission = (moduleId: string) => {
    return permissionsInfo?.find((p) => p.module_id === moduleId);
  };

  // Check if a module should be visible/active based on subscription and unit-level permissions
  const isEnabled = (
    moduleId: string,
    checkFor: 'route' | 'module' = 'module',
  ): boolean => {
    if (moduleId === 'default') {
      return true;
    }
    // 1. Check if module is part of the organization's active subscription
    const inSubscription = activeModuleIds.length
      ? activeModuleIds.includes(moduleId)
      : true;

    if (!inSubscription) return false;

    // 2. Hide module if explicitly restricted for this user's role
    const permission = getPermission(moduleId);
    if (checkFor === 'route' && permission?.access === 'RESTRICT') return false;

    return true;
  };

  // Get the access level (VIEW, EDIT, etc.) for a specific module
  const getModuleAccess = (moduleId: string) => {
    return getPermission(moduleId)?.access || 'VIEW';
  };

  return {
    isEnabled,
    getPermission,
    getModuleAccess,
    permissionsInfo,
    MODULES,
  };
};

export default useModuleStatus;
